import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { DialogService } from './_core/services/dialog.service';
import { MessageDialogComponent } from './_shared/message-dialog/message-dialog.component';
import packageJson from '../../package.json';
import { filter, map, mergeMap, of, Subject, tap } from 'rxjs';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Sagitta';
  version = packageJson.version;

  displayLogoMediazione = false;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private swUpdate: SwUpdate,
    private dialogService: DialogService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.iconRegistry.addSvgIcon(
      'upload',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/upload.svg')
    );
  }

  ngOnInit(): void {
    this.subscribeToSw();
    this.subscribeToNavigationEvents();
  }

  private checkDisplayMediazione(lastRoute: ActivatedRouteSnapshot) {
    let [praticaSegment, idSegment, sectionSegment] =
      lastRoute['_urlSegment'].segments;
    let isPraticaFlow =
      praticaSegment?.path === 'pratica' && sectionSegment?.path !== 'score';
    let isOpening =
      praticaSegment?.path === 'home' && idSegment?.path === 'opening';
    if (isPraticaFlow || isOpening) {
      this.displayLogoMediazione = true;
    } else {
      this.displayLogoMediazione = false;
    }
  }

  private subscribeToNavigationEvents() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let lastRoute = this.activatedRoute.snapshot;
          while (lastRoute.firstChild) {
            lastRoute = lastRoute.firstChild;
          }
          return lastRoute;
        })
      )
      .subscribe((lastRoute) => this.checkDisplayMediazione(lastRoute));
  }

  private subscribeToSw() {
    console.log('sw is enabled:');
    console.log(this.swUpdate.isEnabled);

    if (!this.swUpdate.isEnabled) return;
    this.swUpdate.versionUpdates
      .pipe(
        tap((versionEvent) => console.log(versionEvent)),
        mergeMap((versionEvent) =>
          !!versionEvent && versionEvent.type === 'VERSION_READY'
            ? this.dialogService
                .open<MessageDialogComponent, MessageDialogComponent['data']>(
                  MessageDialogComponent,
                  {
                    data: {
                      message: 'Nuova versione dispoinibile.',
                      title: 'Attenzione',
                      confirmButtonColor: 'accent',
                      buttonConfirmText: 'Ok',
                    },
                  }
                )
                .afterClosed()
                .pipe(map((_) => true))
            : of(false)
        )
      )
      .subscribe((isUpated) => isUpated && window.location.reload());
  }
}
